import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  cloneDeep,
  findIndex,
  get,
  groupBy,
  padStart,
  sortBy,
  isEmpty,
  filter,
} from 'lodash';
import Lightbox from 'react-images';
import { connect } from 'react-redux';
import { Prompt } from 'react-router-dom';
import {
  compose,
  setDisplayName,
} from 'recompose';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@material-ui/core/CircularProgress';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import { withStyles } from '@material-ui/core/styles';
import { WarningRounded as WarningIcon, InfoOutlined } from '@material-ui/icons';

import immutableToJS from 'helpers/immutableToJS';
import {
  dispatchRestMaker,
  formatPrice,
  getValidatedPackrows,
  includesSearchText,
  addTagValue,
  scrollTo,
  sortItems,
  toShortDateTimeFormat,
  toStartCaseWithSlash,
  packrowsWithOriginalValues,
  isDistributor,
  decimalFixed,
  toStartCase,
} from 'helpers/utils';
import {
  HighlightText,
  injectIntl,
  Pagination,
  PaginationContainer,
  Tags,
  SmartForm,
} from 'components';
import { FRInput } from 'elements';
import goodActions, { goodsUploadImageActions, goodsImageActions } from 'redux/goods/actions';
import { selectState } from 'redux/selectors';
import storeActions, { storeItemsImageActions } from 'redux/storeItems/actions';
import AddItemButton from './AddItemButton';
import GridView from './GridView';
import MobileGridView from './GridView/MobileGridView';
import ProductItemImage from './ProductItemImage';
import StoreTable from './StoreTable';
import AddressForm from '../../Profile/components/AddressForm';
import DeliverySchedule from '../../Profile/components/DeliverySchedule';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import CategoryDrawer from '../../OrderSheet/components/CategoryDrawer';

const styles = () => ({
  activeCategoryBtn: { backgroundColor: '#4695ec' },
  activeCategoryBtnLabel: { color: '#fff' },
  activeViewModeButton: {
    color: '#0093ff',
    height: '1.5em',
    width: '1.5em',
  },
  categoryBtn: {
    backgroundColor: '#fff',
    borderRadius: 5,
    marginBottom: 5,
    marginRight: 10,
  },
  categoryBtnLabel: {
    color: '#4695ec',
    fontSize: 12,
    fontWeight: 600,
  },
  disabledInput: {
    backgroundColor: '#dcdcdc',
    fontSize: 12,
    height: 25,
    maxWidth: 50,
    width: 50,
  },
  flexWrap: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  inputDisabled: {
    color: '#808080',
    fontSize: 12,
    fontWeight: 300,
    height: '90%',
    padding: '8px 5px 4px 5px',
    maxWidth: 45,
    width: 45,
  },
  inputDisabledForQty: {
    color: '#808080',
    fontSize: 14,
    fontWeight: 500,
    height: 20,
    maxWidth: 45,
    width: 45,
    padding: 0,
    paddingLeft: 4,
  },
  inputNormal: {
    color: '#000',
    fontSize: 12,
    fontWeight: 300,
    height: 20,
    padding: '5px 5px 4px 5px',
  },
  inputNormalForQty: {
    color: '#000 ',
    fontSize: 14,
    fontWeight: 500,
    height: 20,
    padding: '5px 5px 4px 5px',
  },
  inputNormalForCost: {
    color: '#459dfe',
    fontSize: 14,
    fontWeight: 500,
    height: 20,
    padding: '8px 5px 4px 5px',
  },
  inputZero: {
    color: 'red',
    fontSize: 12,
    fontWeight: 'normal',
    fontStyle: 'italic',
    height: 20,
    padding: '8px 5px 4px 5px',
    backgroundColor: 'pink',
  },
  inputZeroForQty: {
    color: 'red', // change color from #f86c6b to black and then to red
    fontSize: 14,
    fontStyle: 'italic',
    fontWeight: 'normal',
    height: 20,
    padding: '5px 5px 4px 5px',
    backgroundColor: 'pink',
  },
  normalInput: {
    backgroundColor: '#fff',
    height: 32,
    maxWidth: 50,
    width: 50,
  },
  normalViewModeButton: {
    color: 'black',
    height: '1.5em',
    width: '1.5em',
  },
  qtyInput: {
    fontStyle: 'italic',
    fontSize: 12,
    height: 25,
    maxWidth: 45,
    width: 45,
  },
  red: { color: 'red' },
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
  },
  sortBtnLabel: {
    color: '#ff5722',
    fontSize: '0.65rem',
    fontWeight: 600,
    textTransform: 'none',
  },
  toggle: { width: 105 },
  tab: { backgroundColor: '#ffffff', minWidth: 80 },
  tabIndicator: { backgroundColor: '#5b98ed' },
  tabLabel: {
    fontWeight: 600,
    color: '#5b98ed',
  },
  tabsContainer: {
    marginRight: '35px'
  },
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0px 1px 0px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12)',
    borderRadius: '1px !important'
  },
  cardMedia: {
    paddingTop: '60%',
  },
  cardContent: {
    flexGrow: 1,
    paddingLeft: '8px',
    paddingRight: '8px',
    paddingBottom: '5px !important'
  },
  cardMobile: {
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
  },
  cardMediaMobile: {
    width: '80px',
  },
  cardContentMobile: {
    flexGrow: 1,
    paddingLeft: '10px',
    paddingRight: '10px',
    paddingTop: '8px',
    paddingBottom: '10px !important'
  }
});

const alertArrowStyle = {
  color: '#f86c6b',
  fontSize: '30px',
};

class StoreCardDetails extends Component {
  static contextTypes = {
    currentUser: PropTypes.shape({}),
    setHotNotification: PropTypes.func,
  };

  static propTypes = {
    classes: PropTypes.shape({}).isRequired,
    createGoodsUploadImage: PropTypes.func.isRequired,
    details: PropTypes.arrayOf(
      PropTypes.shape({}),
    ),
    // farmMode: PropTypes.bool,
    globals: PropTypes.arrayOf(PropTypes.shape({})),
    goodsUploadImageRequesting: PropTypes.bool.isRequired,
    iconDirectionForAlertOrder: PropTypes.node.isRequired,
    iconDirectionForTimestampOrder: PropTypes.node.isRequired,
    info: PropTypes.shape({
      id: PropTypes.number,
      companyName: PropTypes.string,
    }),
    isCatalog: PropTypes.bool,
    isFarm: PropTypes.bool,
    isMarketPlace: PropTypes.bool,
    isWarehouse: PropTypes.bool,
    isMobile: PropTypes.bool,
    readOnly: PropTypes.bool,
    readOnlyForPermission: PropTypes.bool,
    requesting: PropTypes.bool,
    searchText: PropTypes.string,
    /* eslint-disable-next-line */
    sortOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    storeCardPrint: PropTypes.node.isRequired,
    storeItemsImageRequesting: PropTypes.bool.isRequired,
    createStoreItemsImage: PropTypes.func.isRequired,
    removeStoreItemsImage: PropTypes.func.isRequired,
    removeGoodsImage: PropTypes.func.isRequired,
    formatMessage: PropTypes.func.isRequired,
    onSortAlert: PropTypes.func.isRequired,
    onSortTimeStamp: PropTypes.func.isRequired,
    reloadStore: PropTypes.func.isRequired,
    // toggleForFarmMode: PropTypes.func,
    updateGoodItem: PropTypes.func.isRequired,
    updateStoreItem: PropTypes.func.isRequired,
    isAllowedToUpdate: PropTypes.bool,
    isRetailPage: PropTypes.bool,
    updateProfile: PropTypes.func.isRequired,
  };

  static defaultProps = {
    details: [],
    globals: [],
    // farmMode: false,
    info: {},
    isCatalog: false,
    isFarm: false,
    isMarketPlace: false,
    isWarehouse: false,
    isMobile: false,
    readOnly: false,
    readOnlyForPermission: false,
    requesting: false,
    searchText: '',
    // toggleForFarmMode: null,
    isAllowedToUpdate: true,
    isRetailPage: false,
  };

  state = {
    // filterCategories: [],
    currentImage: 0,
    currentPageIndex: 1,
    dataFiltered: [],
    focusedPrice: {},
    lightboxIsOpen: false,
    showMode: true,
    open: false,
    dialogMessage: '',
    focusedPacks: {},
    focusedBulk: {},
    focusedCost: {},
    dirty: false,
  };

  componentWillMount() {
    // this.refreshCategories(this.props);
    this.setState({ dataFiltered: this.getDataWithoutFilter(this.props) });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.searchText !== nextProps.searchText) {
      const dataItems = this.getDataWithoutFilter(nextProps);
      const updatedData = this.updateDetailsData(dataItems);
      this.setState({
        currentPageIndex: 1,
        dataFiltered: updatedData,
      });
    } else if (JSON.stringify(this.props.details) !== JSON.stringify(nextProps.details)
      || this.props.sortOptions !== nextProps.sortOptions) {
      const dataItems = this.getDataWithoutFilter(nextProps);
      const updatedData = this.updateDetailsData(dataItems);
      this.setState({ dataFiltered: updatedData });
    }
  }

  onPageClick = (currentPageIndex) => {
    setTimeout(() => scrollTo('store-detail'), 100);
    this.setState({ currentPageIndex });
  };

  getDataWithoutFilter = ({
    details,
    isCatalog,
    isFarm,
    isMarketPlace,
    isWarehouse,
    searchText,
    sortOptions,
    tags,
  }) => {
    const data = [];

    if (details) {
      const taggedItems = addTagValue(details, tags);

      taggedItems.forEach((itemInfo) => {
        if (isCatalog) {
          if (!itemInfo.approved || (itemInfo.productData.approved === false
            && itemInfo.storeItemId)) {
            return;
          }
        }

        if (itemInfo.productData.approved === false && itemInfo.storeItemId) {
          return;
        }

        if (!isCatalog && !isWarehouse &&
          itemInfo.approved === false && itemInfo.sourceApproved === false) {
          return;
        }

        const count = itemInfo.packrows.length > 0 ? itemInfo.packrows[0].count : 0;
        const availableQuantity = itemInfo.packrows.length > 0 ? itemInfo.packrows[0].isBulk ? itemInfo.availableQuantity : itemInfo.packrows[0].availableQuantity : 0;
        const price = itemInfo.packrows.length > 0 ? itemInfo.packrows[0].price : 0;
        const originCompanyName = this.props.info.companyName || '';
        const packRowsInCatalog = itemInfo.packrows.filter(pack => (Math.trunc(pack.availableQuantity) > 0 && !itemInfo.sellerAccountId) || (itemInfo.sellerAccountId && parseFloat(pack.cost, 10) > 0)) || [];
        const packRowsInAvailableList = itemInfo.packrows.filter(pack => !itemInfo.sellerAccountId || (itemInfo.sellerAccountId && parseFloat(pack.cost, 10) > 0)) || [];
        if ((isCatalog && packRowsInCatalog.length > 0 && parseFloat(availableQuantity) > 0) || (!isCatalog && packRowsInAvailableList.length > 0)) {
          data.push({
            ...itemInfo,
            packrows: isCatalog ? packRowsInCatalog : packRowsInAvailableList,
            sourcename: isMarketPlace ? (
              get(itemInfo, 'user.account.profile.companyName') || '') :
              (!isFarm && !isMarketPlace
                ? (itemInfo.seller.companyName || originCompanyName)
                : originCompanyName),
            count,
            availableQuantity,
            price,
            isBulk: itemInfo.packrows[0].isBulk,
          });
        }
      });
    }

    const filteredData = data.filter(subItem => includesSearchText(
      searchText,
      [
        subItem.description,
        toStartCaseWithSlash(subItem.productData.category),
        subItem.productData.name,
        subItem.productData.subname,
        subItem.sourcename,
        subItem.tags.join(' '),
      ],
    ));

    return sortItems(filteredData, sortOptions, isCatalog, isWarehouse);
  }

  handleClickOpen = (dialogMessage) => {
    this.setState({ open: true, dialogMessage });
  };

  handleClose = () => {
    this.setState({ open: false, dialogMessage: '' });
  };

  setFormDirty = () => {
    this.setState({ dirty: true });
  };

  updateDeliverySchedule = (deliverySchedule) => {
    this.deliverySchedule = deliverySchedule;
    this.setFormDirty();
  };

  getFormFields = (details) => {
    const {
      currentUser,
    } = this.context;
    const {
      formatMessage,
      isRetailPage,
    } = this.props;
    const deliverySchedule = get(currentUser.organizations[0].account, 'profile.deliverySchedule');
    const currentAccount = currentUser.account || {}; // login as

    const companyFields = [];
    companyFields.push({
      fieldName: 'shopHeader',
      kind: 'input',
      label: formatMessage('Shop Header'),
      fullWidth: true,
      name: 'shopHeader',
    });
    companyFields.push({
      fieldName: 'shopBody',
      kind: 'textarea',
      label: formatMessage('Shop Body'),
      fullWidth: true,
      name: 'shopBody',
    });
    companyFields.push({
      kind: 'blank',
    });
    companyFields.push({
      fieldName: 'deliveryHeader',
      kind: 'input',
      label: formatMessage('Delivery Header'),
      name: 'deliveryHeader',
    });
    companyFields.push({
      kind: 'blank',
    });
    companyFields.push({
      fieldName: 'deliveryBody',
      kind: 'textarea',
      label: formatMessage('Delivery Body'),
      name: 'deliveryBody',
    });

    if (currentAccount.currentRoleId) {
      companyFields.push(
        {
          kind: 'blank',
          label: (
            <DeliverySchedule
              deliverySchedule={deliverySchedule}
              formatMessage={formatMessage}
              update={this.updateDeliverySchedule}
            />
          ),
          name: 'delivery-schedule-calendar',
        },
      );
    }

    companyFields.push({
      fieldName: 'firstName',
      kind: 'checkbox',
      label: formatMessage('Delivery To'),
      name: 'deliveryTo',
      defaultValue: details.deliveryTo && JSON.parse(details.deliveryTo) ? '1' : '0',
    });
    companyFields.push({
      kind: 'blank',
    });
    companyFields.push({
      fieldName: 'lastName',
      kind: 'checkbox',
      label: formatMessage('Pick-Up'),
      name: 'pickUp',
      defaultValue: details.pickUp && JSON.parse(details.pickUp) ? '1' : '0',
    });
    companyFields.push(
      {
        className: 'font-weight-500',
        kind: 'blank',
        label: (
          <AddressForm
            addresses={get(currentAccount, 'profile.addresses') || []}
            onUpdate={this.setFormDirty}
            isRetailPage={isRetailPage}
          />
        ),
        fullWidth: true,
        name: 'addresses',
      },
    );
    return companyFields;
  };

  updateProfile = (data) => {
    const { updateProfile } = this.props;

    const addresses = [];
    if (data.address) {
      if (typeof data.address === 'string') {
        addresses.push({
          address: data.address,
          city: data.city,
          state: data.state,
          zipcode: data.zipcode,
        });
      } else {
        for (let i = 0; i < data.address.length; i++) {
          if (
            data.address[i].trim() !== '' ||
            data.city[i].trim() !== '' ||
            data.state[i].trim() !== '' ||
            data.zipcode[i].trim() !== ''
          ) {
            addresses.push({
              address: data.address[i],
              city: data.city[i],
              state: data.state[i],
              zipcode: data.zipcode[i],
            });
          }
        }
      }
    }

    const modifiedData = {
      shopHeader: data.shopHeader,
      shopBody: data.shopBody,
      deliveryHeader: data.deliveryHeader,
      deliveryBody: data.deliveryBody,
      addresses,
      deliverySchedule: this.deliverySchedule,
      deliveryTo: data.deliveryTo && Boolean(Number(data.deliveryTo)) === true,
      pickUp: data.pickUp && Boolean(Number(data.pickUp)) === true,
    };

    updateProfile(modifiedData);
    this.setState({ dirty: false });
  }

  getFields = (isMobile = false) => {
    const {
      currentUser,
      setHotNotification,
    } = this.context;
    const {
      classes,
      formatMessage,
      iconDirectionForAlertOrder,
      iconDirectionForTimestampOrder,
      info,
      isCatalog,
      isFarm,
      isMarketPlace,
      searchText,
      onSortAlert,
      onSortTimeStamp,
      readOnly,
      readOnlyForPermission,
      reloadStore,
      storeItemsImageRequesting,
      goodsUploadImageRequesting,
      isWarehouse,
      globals,
      isAllowedToUpdate,
      isRetailPage,
    } = this.props;
    const fields = [];
    if (isMobile) {
      fields.push({
        label: '',
        render: row => (
          <div className="mobile-group-data-first">
            <div className={`mobile-group-data-item mr-2 highlight weight-500 ${row.approved ? '' : 'disable'}`}
              style={{fontSize:'20px'}}
            >
              <HighlightText
                highlight={searchText}
                text={[row.name, row.subname].join(', ')}
              />
            </div>
            {
              row.tags ? (
                <div className={classes.flexWrap}>
                  <Tags
                    approved={row.approved}
                    defaultTags={row.tags}
                    removable={false}
                    showDropdown={false}
                    size="small"
                  />
                </div>
            ) : null
            }
            {
              isCatalog || (!isFarm && !isWarehouse) ? (
                <div className="ml-2">
                    {row.imageMobile ? (
                     <img
                      src={row.imageMobile}
                      alt={row.imageMobile}
                      style={{
                        height: 50,
                        objectFit: 'unset',
                        width: 50,
                        cursor: 'pointer',
                      }}
                      onClick={() => this.openLightbox(row)}
                    />
                    ) : null}
                  </div>
              ) : ( 
                <div className="ml-2">
                  <ProductItemImage
                    disabled={readOnlyForPermission}
                    onUpload={this.handleUploadImage()}
                    onRemove={this.handleRemoveImage()}
                    image={row.imageMobile ? row.imageMobile : row.image}
                    info={row}
                    reloadStore={reloadStore}
                    requesting={isFarm ?
                      storeItemsImageRequesting : goodsUploadImageRequesting}
                    title={formatMessage('Add Photo')}
                  />
                </div>      
              )
            }
          </div>
        ),
      });
    } else {
      //Show Image as first element in Availability list
      ((!isFarm && !isWarehouse && !isCatalog) && fields.push({ label: '', name: 'image', title: () => '', colSpan: 1 }));

      fields.push({
        className: data => `${`highlight normal-font large-font-for-mobile ${data.approved ? '' : 'disable'}`}`,
        colSpan: 2,
        label: formatMessage('IN'),
        name: 'name',
        render: data =>
          (
            <span className="item-name-pane">
              <div
                title={data.name}
              >
                <HighlightText
                  className="white-space"
                  highlight={searchText}
                  text={data.name}
                />
              </div>
            </span>
          ),
        title: row => row.name,
      });
      fields.push({
        className: data => `${`highlight normal-font big-font-for-mobile ${data.approved ? '' : 'disable'}`}`,
        colSpan: 2,
        label: formatMessage('ISN'),
        name: 'subname',
        render: data => (
          <span className="item-sub-name">
            <HighlightText
              highlight={searchText}
              text={data.subname}
            />
          </span>
        ),
        title: row => row.subname,
      });
      const infoLabelName = isWarehouse ? 'Vendor' : 'Info';
      fields.push({
        className: 'info tiny-font',
        colSpan: 2,
        label: formatMessage(infoLabelName),
        name: 'description',
        render: row => (  
          <span style ={{lineHeight:'15px'}}>
            {row.description ? (`${row.description.substr(0, 57)}${row.description.length > 57 ? '...' : ''}`) : ''}
          </span>),
        title: row => row.description,
      });
      fields.push({
        colSpan: 3,
        label: formatMessage('Tags'),
        name: 'tags',
        render: data => (data.tags ? (
          <div className={classes.flexWrap}>
            <Tags
              approved={data.approved}
              defaultTags={data.tags}
              removable={false}
              showDropdown={false}
              size="small"
              highlightText={searchText}
            />
          </div>
        ) : null),
        title: () => '',
      });
    }
    if (!isFarm && !isMobile && !isWarehouse) {
      fields.push({
        className: data => `${`tiny-font ${data.approved ? '' : 'disable'}`}`,
        colSpan: 2,
        label: formatMessage('Vendor'),
        name: 'sourcename',
        render: data => (
          <HighlightText
            highlight={searchText}
            text={data.sourcename}
          />
        ),
        title: row => row.sourcename || '',
      });
    }
    const qty = row => (
      <span className="no-edit-qty">
        {
          (isCatalog || readOnly || row.isBulk) ? (
            <span className={`${row.approved ? 'normal-font' : 'disable'} ${!isFarm && !isCatalog && !isMarketPlace && Math.trunc(parseFloat(row.availableQuantity, 10)) === 0 ? 'red' : Math.trunc(parseFloat(row.availableQuantity, 10)) > 0 ? 'font-weight-500' : ''}`}> 
              {row.availableQuantity === '' ? '0' : Math.trunc(parseFloat(row.availableQuantity, 10))}
            </span>
          ) : (
            <FRInput
              classes={{ root: row.approved ? classes.normalInput : styles.disabledInput }}
              className={`store-edit-qty ${Math.trunc(this.state.focusedPacks[`${row.id}_${row.index}`] ? this.state.focusedPacks[`${row.id}_${row.index}`].packs : (!row.availableQuantity ? '0' : Math.trunc(parseFloat(row.availableQuantity, 10)))) > 0 ? 'font-weight-500' : ''}`}
              // defaultValue={!row.availableQuantity ?
              //   '0' : Math.trunc(parseFloat(row.availableQuantity, 10))}
              disabled={readOnlyForPermission}
              value={this.state.focusedPacks[`${row.id}_${row.index}`]
                ? this.state.focusedPacks[`${row.id}_${row.index}`].packs
                : (!row.availableQuantity ? '0' : Math.trunc(parseFloat(row.availableQuantity, 10)))
              }
              id="availableQuantity"
              InputProps={{
                classes: {
                  input: row.approved ? (
                    (parseInt(row.availableQuantity, 10) === 0 || !row.availableQuantity)
                      ? classes.inputZero
                      : classes.inputNormal
                    )
                  : classes.inputDisabled,
                },
              }}
              key={row.availableQuantity}
              name="availableQuantity"
              onBlur={(e) => {
                this.setFocusedPacks(`${row.id}_${row.index}`, false);
                const newPackRows = cloneDeep(row.packrows);
                const floatValue = parseFloat(e.target.value || 0);

                if (!e.target.value) {
                  e.target.value = 0;
                }
                if (floatValue < 0) {
                  return;
                }
                if (floatValue !== parseFloat(newPackRows[row.index].availableQuantity) || e.target.value === '') {
                  newPackRows[row.index].availableQuantity = Math.trunc(floatValue);

                  const updated = {
                    packrows: packrowsWithOriginalValues(newPackRows),
                    noDispatch: true,
                  };
                  this.updateStateData(row.instance, updated);
                }
              }}
              onFocus={(e) => {
                if (Math.trunc(e.target.value) === 0) {
                  this.setFocusedPacks(`${row.id}_${row.index}`, true, '');
                }
              }}
              onChange={(event) => {
                event.preventDefault();
                const { target: { value } } = event;
                if (parseFloat(value || 0) < 0) {
                  setHotNotification('Should not be less than 0');
                }
                event.target.value = value && Math.trunc(value) !== 0 ? Math.trunc(value) : '';
                this.setFocusedPacks(`${row.id}_${row.index}`, true, event.target.value);
              }}
              title={formatMessage('Qty')}
              type="number"
              variant="outlined"
              disabled={!isAllowedToUpdate}
            />
          )
        }
      </span>
    );
    const bulk = row => (
      <span className="qty-alert">
        {
          row.isBulk ? (!isCatalog && row.isMinCount && !readOnly ? (
            <FRInput
              classes={{ root: classes.qtyInput }}
              value={this.state.focusedBulk[`${row.id}_${row.index}`]
              ? this.state.focusedBulk[`${row.id}_${row.index}`].bulk
              : (parseFloat(row.bulkTotalQty) === 0 || !row.bulkTotalQty ? '0' : decimalFixed(row.bulkTotalQty))
              }
              disabled={readOnlyForPermission}
              id="availableQuantity"
              InputProps={{
                classes: {
                  input: row.approved ? (
                    (parseFloat(row.bulkTotalQty) === 0 || !row.bulkTotalQty)
                      ? classes.inputZeroForQty
                      : classes.inputNormalForQty
                    )
                  : classes.inputDisabledForQty,
                },
              }}
              key={row.bulkTotalQty}
              name="availableQuantity"
              onFocus={(e) => {
                if (Math.trunc(e.target.value) === 0) {
                  this.setFocusedBulk(`${row.id}_${row.index}`, true, '');
                }
              }}
              onBlur={(e) => {
                this.setFocusedBulk(`${row.id}_${row.index}`, false);
                const intValue = decimalFixed(e.target.value);
                const rowBulkTotalQty = decimalFixed(row.bulkTotalQty);

                if (!e.target.value) {
                  e.target.value = 0;
                }
                if (intValue < 0) {
                  return;
                }
                if (intValue !== rowBulkTotalQty || e.target.value === '') {
                    const newPackrows = row.packrows.slice().map(item => ({
                      ...item,
                      availableQuantity: Math.trunc(intValue / (item.count || 1), 10),
                    }));
                    const updated = {
                      availableQuantity: intValue,
                      noDispatch: true,
                      packrows: packrowsWithOriginalValues(newPackrows),
                    };
                    this.updateStateData(row.instance, updated);
                  }
              }}
              onChange={(event) => {
                event.preventDefault();
                const { target: { value } } = event;
                if (parseFloat(value || 0) < 0) {
                  setHotNotification('Should not be less than 0');
                }
                event.target.value = value && decimalFixed(value) !== 0 ? decimalFixed(value) : '';
                this.setFocusedBulk(`${row.id}_${row.index}`, true, event.target.value);
              }}
              title={formatMessage('Qty')}
              type="number"
              variant="outlined"
              disabled={!isAllowedToUpdate}
            />
          ) : (
            <span className={`${row.isBulk && row.isMinCount ? '' : 'hide'} ${row.approved ? 'normal-font red' : 'disable'} ${ decimalFixed(row.bulkTotalQty) > 0 ? 'font-weight-500' : 'red'}`}>
              {row.bulkTotalQty === '' ? '0' : decimalFixed(row.bulkTotalQty)}
            </span>
          )) : (
            ''
          )
        }
      </span>
    );

    if (isMobile) {
      fields.push({

        }
      );
      fields.push({
        label: '',
        render: (row) => {
          const rowId = `${row.id}_${row.index}`;
          return (
            <Fragment>
              {isWarehouse ? (
                <Fragment>
                  {row.index === 0 && (
                    <div className="row normal-font ml-0 mr-0 " style={{fontSize: '12px'}}>
                      <div className="col-3"> </div>
                      <div className="col-3" style={{textAlign: 'center'}}> {formatMessage('price')}</div>
                      <div className="col-3 blue" style={{textAlign: 'center'}}> {formatMessage('cost')}</div>
                      <div className="col-3"></div>
                    </div>
                  )}
              
                <div className={`mobile-group-data row ml-0 mr-0 mt-2 ${row.isBulk ? 'mb-2' : ''}`}>
                  <div style={{ justifyContent: 'flex-start' }} className="mobile-group-data-item normal-font col-3 pl-0 pr-0 ">
                    {row.count} {row.uom} {row.pack}
                  </div>
                  <div style={{ justifyContent: 'center', fontWeight: '500' }} className="price-group d-flex mobile-group-data-item col-3  pl-0 pr-0">
                    {/* Total Price */}
                    <span style={{ alignItems: 'flex-end', display: 'flex' }}>
                      <span>$&nbsp;</span>
                      <FRInput
                        forceBlur
                        classes={{
                          root: row.approved ?
                            classes.normalInput : styles.disabledInput
                        }}
                        id="price"
                        InputProps={{
                          classes: {
                            input: row.approved ? ((row.price === '0.00' || !row.price) ? classes.inputZeroForQty : classes.inputNormalForQty) : classes.inputDisabledForQty,
                          },
                        }}
                        min={0}
                        name="price"
                        key={row.price}
                        onFocus={() => {
                          this.setFocusedPrice(rowId, true, '');
                        }}
                        onBlur={({ target: { value } }) => {
                          this.setFocusedPrice(rowId, false);
                          if (value === '') return;
                          const floatValue = parseFloat(value || 0);
                          if (floatValue < 0) {
                            return;
                          }
                          if (floatValue !== parseFloat(row.price) || value === '') {
                            let newPackrows = cloneDeep(row.packrows);
                            newPackrows = packrowsWithOriginalValues(newPackrows);
                            newPackrows[row.index].price = floatValue.toFixed(2);

                            const updated = {
                              packrows: newPackrows,
                              noDispatch: true,
                            };
                            this.updateStateData(row.instance, updated);
                          }
                        }}
                        onChange={(event) => {
                          event.preventDefault();
                          const { target: { value } } = event;
                          if (parseFloat(value || 0) < 0) {
                            setHotNotification('Should not be less than 0 or bigger than original quantity');
                          }
                          this.setFocusedPrice(rowId, true, value);
                        }}
                        type="number"
                        value={this.state.focusedPrice[rowId]
                          ? this.state.focusedPrice[rowId].price
                          : (parseFloat(row.price) === 0 || !row.price ? '0.00' : parseFloat(row.price).toFixed(2))
                        }
                        variant="outlined"
                      />
                    </span>
                    {/* Price */}
                    <span className="grey" style={{ paddingLeft: '8px', color: '#459dfe' }}>
                      {
                        !isFarm && info.id && row.storeItemId ? (
                          <span className={`${isCatalog && row.cost === row.price ? 'red' : ''}`}>
                            ${formatPrice(((row.cost * (100 - (row.discount || 0))) / 100))}
                          </span>
                        ) : ''
                      }
                    </span>
                  </div>
                 
                  {/* Cost */}
                  <div className={'normal-font col-3 pl-0 pr-0'}>
                    <span style={{verticalAlign:'bottom'}}>$&nbsp;</span>
                    <FRInput
                      forceBlur
                      classes={{ root: row.approved ? classes.normalInput : styles.disabledInput }}
                      id="cost"
                      InputProps={{
                        classes: {
                          input: row.approved ? ((row.price === '0.00' || !row.price || row.price <= row.cost) ? classes.inputZeroForQty : classes.inputNormalForCost) : classes.inputDisabledForQty,
                        },
                      }}
                      min={0}
                      name="cost"
                      key={row.cost}
                      onFocus={() => {
                        this.setFocusedCost(rowId, true, '');
                      }}
                      onBlur={({ target: { value } }) => {
                        this.setFocusedCost(rowId, false);
                        if (value === '') return;
                        const floatValue = parseFloat(value || 0);
                        if (floatValue < 0) {
                          return;
                        }
                        if (floatValue !== parseFloat(row.cost) || value === '') {
                          let newPackrows = cloneDeep(row.packrows);
                          newPackrows = packrowsWithOriginalValues(newPackrows);
                          newPackrows[row.index].cost = floatValue.toFixed(2);
                          const updated = {
                            packrows: newPackrows,
                            noDispatch: true,
                          };
                          this.updateStateData(row.instance, updated);
                        }
                      }}
                      onChange={(event) => {
                        event.preventDefault();
                        const { target: { value } } = event;
                        if (parseFloat(value || 0) < 0) {
                          setHotNotification('Should not be less than 0 or bigger than original quantity');
                        }
                        this.setFocusedCost(rowId, true, value);
                      }}
                      type="number"
                      value={this.state.focusedCost[rowId]
                        ? this.state.focusedCost[rowId].cost
                        : (parseFloat(row.cost) === 0 || !row.cost ? '0.00' : parseFloat(row.cost).toFixed(2))
                      }
                      variant="outlined"
                    />
                  </div>
                  {/* Bulk */}
                  {row.isBulk && (<div>{bulk(row)}</div>)}

                  {/* Qty */}
                  <div className={`small-font pr-0 ${row.isBulk ? 'col-1' : 'col-3'} ${!isCatalog && !readOnly ? 'pl-0' : ''}`}>
                    <span className="d-flex" style={{ justifyContent: 'center', alignItems: 'center' }}>
                      <span className="red d-flex" style={{ alignItems: 'center' }}>{qty(row)}&nbsp;</span>
                      {!row.isBulk && 
                        <span style={!isCatalog && !readOnly ? { marginRight: 10 } : {}} className="italic">
                        {formatMessage('left')}
                        </span>
                      }
                      
                    </span>
                  </div>
                </div>
                </Fragment>
                ) : (
                  <div className={`mobile-group-data row ml-0 mr-0 mt-2 ${row.isBulk ? 'mb-2' : ''}`}>
                    <div style={{ justifyContent: 'flex-start' }} className="mobile-group-data-item normal-font col-4 pl-0 pr-0 ">
                      {row.count} {row.uom} {row.pack}
                    </div>
                    <div style={{ justifyContent: 'center', fontWeight: '500' }} className="price-group d-flex mobile-group-data-item col-4">
                      {/* Total Price */}
                      <span>
                        {!isFarm ? (
                          <span style={{alignItems: 'center',display: 'flex'}}>
                            $&nbsp;
                          <FRInput
                              forceBlur
                              classes={{
                                root: row.approved ?
                                  classes.normalInput : styles.disabledInput
                              }}
                              id="price"
                              InputProps={{
                                classes: {
                                  input: row.approved ? ((row.price === '0.00' || !row.price) ? classes.inputZeroForQty : classes.inputNormalForQty) : classes.inputDisabledForQty,
                                },
                              }}
                              min={0}
                              name="price"
                              key={row.price}
                              onFocus={() => {
                                this.setFocusedPrice(rowId, true, '');
                              }}
                              onBlur={({ target: { value } }) => {
                                this.setFocusedPrice(rowId, false);
                                if (value === '') return;
                                const floatValue = parseFloat(value || 0);
                                if (floatValue < 0) {
                                  return;
                                }
                                if (floatValue !== parseFloat(row.price) || value === '') {
                                  let newPackrows = cloneDeep(row.packrows);
                                  newPackrows = packrowsWithOriginalValues(newPackrows);
                                  newPackrows[row.index].price = floatValue.toFixed(2);

                                  const updated = {
                                    packrows: newPackrows,
                                    noDispatch: true,
                                  };
                                  this.updateStateData(row.instance, updated);
                                }
                              }}
                              onChange={(event) => {
                                event.preventDefault();
                                const { target: { value } } = event;
                                if (parseFloat(value || 0) < 0) {
                                  setHotNotification('Should not be less than 0 or bigger than original quantity');
                                }
                                this.setFocusedPrice(rowId, true, value);
                              }}
                              type="number"
                              value={this.state.focusedPrice[rowId]
                                ? this.state.focusedPrice[rowId].price
                                : (parseFloat(row.price) === 0 || !row.price ? '0.00' : parseFloat(row.price).toFixed(2))
                              }
                              variant="outlined"
                            />
                          </span>
                        ) : (
                            <span style={{
                              alignItems: 'center',
                              color: 'black',
                              display: 'flex',
                              justifyContent: 'center',
                            }}>
                              $&nbsp;{row.price === '0.00' || !row.price ? '0.00' : row.price}
                            </span>
                          )}
                      </span>

                      {/* Price */}
                      <span className="grey" style={{ paddingLeft: '8px', color: '#459dfe' }}>
                        {
                          !isFarm && info.id && row.storeItemId ? (
                            <span className={`${isCatalog && row.cost === row.price ? 'red' : ''}`}>
                              ${formatPrice(((row.cost * (100 - (row.discount || 0))) / 100))}
                            </span>
                          ) : ''
                        }
                      </span>
                    </div>
                    {row.isBulk && (<div>{bulk(row)}</div>)}
                    <div className={`small-font col-3 pr-0 ${!isCatalog && !readOnly ? 'pl-0' : ''}`}>
                      <span className="d-flex" style={{ justifyContent: 'center', alignItems: 'center' }}>
                        <span className="red d-flex" style={{ alignItems: 'center' }}>{qty(row)}&nbsp;</span>
                        <span style={!isCatalog && !readOnly ? { marginRight: 10 } : {}} className="italic">
                          {formatMessage('left')}
                        </span>
                      </span>
                    </div>
                  </div>
                )}
            </Fragment>
          );
        },
        title: () => '',
      },
        {
          className: 'info',
          colSpan: 2,
          label: formatMessage('info'),
          name: 'description',
          render: row => (
            <div style={{ marginTop: '10px' }} >
              {row.description}
            </div>),
          title: row => row.description,
        }
      );
    } else {
      fields.push({
        className: data => `${`highlight normal-font ${data.approved ? '' : 'disable'}`}`,
        colSpan: 2,
        label: formatMessage('Pack-Out'),
        name: 'uom',
        render: data => <span>{`${decimalFixed(data.count)} ${data.uom} ${data.pack}`}</span>,
        title: data => `${decimalFixed(data.count)} ${data.uom} ${data.pack}`,
      });
      if (isRetailPage) {
        fields.push({ label: formatMessage('Price'),
          className: row => `${`overflow-hidden vp-font ${row.approved ? '' : 'disable'}`}`,
          name: 'price',
          render: (row) => {
            const rowId = `${row.id}_${row.index}`;
            return (
              <FRInput
                forceBlur
                classes={{ root: row.approved ? classes.normalInput : classes.disabledInput }}
                id="price"
                InputProps={{
                  classes: {
                    input: row.approved ? ((row.price === '0.00' || !row.price || (row.price === row.cost)) ? classes.inputZeroForQty : classes.inputNormalForQty) : classes.inputDisabledForQty,
                  },
                }}
                min={0}
                name="price"
                key={row.price}
                onFocus={() => {
                  this.setFocusedPrice(rowId, true, '');
                }}
                onBlur={({ target: { value } }) => {
                  this.setFocusedPrice(rowId, false);
                  if (value === '' && parseFloat(row.price) > 0) {
                    return;
                  }
                  let floatValue = parseFloat(value || 0);
                  if (floatValue < 0) {
                    floatValue = 0;
                  }
                  if (floatValue !== parseFloat(row.price) || value === '') {
                    let newPackrows = cloneDeep(row.packrows);
                    newPackrows = packrowsWithOriginalValues(newPackrows);
                    newPackrows[row.index].price = floatValue.toFixed(2);
                    const updated = {
                      packrows: newPackrows,
                      noDispatch: true,
                    };
                    this.updateStateData(row.instance, updated);
                  }
                }}
                onChange={(event) => {
                  event.preventDefault();
                  const { target: { value } } = event;
                  if (parseFloat(value || 0) < 0) {
                    setHotNotification('Should not be less than 0');
                    // if (inputRef) {
                    //   inputRef.blur();
                    //   inputRef.value = 0;// eslint-disable-line
                    // }
                  }
                  this.setFocusedPrice(rowId, true, value);
                }}
                onKeyUp={(event) => {
                  event.preventDefault();
                  const inputKeyCode = event.keyCode ? event.keyCode : event.which;
                  if (inputKeyCode != null && (inputKeyCode === 189 || inputKeyCode === 187 || inputKeyCode === 69)) {
                    setHotNotification('Should not be less than 0');
                  }
                }}
                type="number"
                value={this.state.focusedPrice[rowId]
                  ? this.state.focusedPrice[rowId].price
                  : (parseFloat(row.price) === 0 || !row.price ? '0.00' : parseFloat(row.price).toFixed(2))
                }
                variant="outlined"
                disabled={!isAllowedToUpdate}
              />
            );
          },
          title: () => '',
        });
      }
      fields.push({
        className: row => (row.isBulk && row.isMinCount ? null : 'hide'),
        colSpan: 2,
        label: formatMessage('Bulk Base'),
        name: 'availableQuantity',
        render: row => bulk(row),
        title: formatMessage('Qty'),
      });
      fields.push({
        colSpan: 2,
        label: formatMessage('Qty'),
        name: 'totalQtyByPack',
        render: row => qty(row),
        title: formatMessage('Qty By Pack'),
      });

      if (isFarm) {
        if (!isRetailPage) {
          fields.push({ label: formatMessage('Price'),
            className: row => `${`overflow-hidden vp-font ${row.approved ? '' : 'disable'}`}`,
            name: 'price',
            render: (row) => {
              const rowId = `${row.id}_${row.index}`;
              return (
                <FRInput
                  forceBlur
                  classes={{ root: row.approved ? classes.normalInput : classes.disabledInput }}
                  id="price"
                  InputProps={{
                    classes: {
                      input: row.approved ? ((row.price === '0.00' || !row.price || (row.price === row.cost)) ? classes.inputZeroForQty : classes.inputNormalForQty) : classes.inputDisabledForQty,
                    },
                  }}
                  min={0}
                  name="price"
                  key={row.price}
                  onFocus={() => {
                    this.setFocusedPrice(rowId, true, '');
                  }}
                  onBlur={({ target: { value } }) => {
                    this.setFocusedPrice(rowId, false);
                    if (value === '' && parseFloat(row.price) > 0) {
                      return;
                    }
                    let floatValue = parseFloat(value || 0);
                    if (floatValue < 0) {
                      floatValue = 0;
                    }
                    if (floatValue !== parseFloat(row.price) || value === '') {
                      let newPackrows = cloneDeep(row.packrows);
                      newPackrows = packrowsWithOriginalValues(newPackrows);
                      newPackrows[row.index].price = floatValue.toFixed(2);
                      const updated = {
                        packrows: newPackrows,
                        noDispatch: true,
                      };
                      this.updateStateData(row.instance, updated);
                    }
                  }}
                  onChange={(event) => {
                    event.preventDefault();
                    const { target: { value } } = event;
                    if (parseFloat(value || 0) < 0) {
                      setHotNotification('Should not be less than 0');
                      // if (inputRef) {
                      //   inputRef.blur();
                      //   inputRef.value = 0;// eslint-disable-line
                      // }
                    }
                    this.setFocusedPrice(rowId, true, value);
                  }}
                  onKeyUp={(event) => {
                    event.preventDefault();
                    const inputKeyCode = event.keyCode ? event.keyCode : event.which;
                    if (inputKeyCode != null && (inputKeyCode === 189 || inputKeyCode === 187 || inputKeyCode === 69)) {
                      setHotNotification('Should not be less than 0');
                    }
                  }}
                  type="number"
                  value={this.state.focusedPrice[rowId]
                    ? this.state.focusedPrice[rowId].price
                    : (parseFloat(row.price) === 0 || !row.price ? '0.00' : parseFloat(row.price).toFixed(2))
                  }
                  variant="outlined"
                  disabled={!isAllowedToUpdate}
                />
              );
            },
            title: () => '',
          });
        }
      } else {
        if (isWarehouse) {
          fields.push({
            colSpan: 2,
            label: formatMessage('Cost'),
            name: 'cost',
            render: (row) => {
              const rowId = `${row.id}_${row.index}`;
              return (
                <Fragment>
                  <FRInput
                    forceBlur
                    classes={{ root: row.approved ? classes.normalInput : classes.disabledInput }}
                    id="cost"
                    InputProps={{
                      classes: {
                        input: row.approved ? ((row.price === '0.00' || !row.price || row.price <= row.cost) ? classes.inputZeroForQty : classes.inputNormalForCost) : classes.inputDisabledForQty,
                      },
                    }}
                    min={0}
                    name="cost"
                    key={row.cost}
                    onFocus={() => {
                      this.setFocusedCost(rowId, true, '');
                    }}
                    onBlur={({ target: { value } }) => {
                      this.setFocusedCost(rowId, false);
                      if (value === '' && parseFloat(row.cost) > 0) {
                        return;
                      }
                      let floatValue = parseFloat(value || 0);
                      if (floatValue < 0) {
                        floatValue = 0;
                      }
                      if (floatValue !== parseFloat(row.cost) || value === '') {
                        let newPackrows = cloneDeep(row.packrows);
                        newPackrows = packrowsWithOriginalValues(newPackrows);
                        newPackrows[row.index].cost = floatValue.toFixed(2);
                        const updated = {
                          packrows: newPackrows,
                          noDispatch: true,
                        };
                        this.updateStateData(row.instance, updated);
                      }
                    }}
                    onChange={(event) => {
                      event.preventDefault();
                      const { target: { value } } = event;
                      if (parseFloat(value || 0) < 0) {
                        setHotNotification('Should not be less than 0');
                      }
                      this.setFocusedCost(rowId, true, value);
                    }}
                    onKeyUp={(event) => {
                      event.preventDefault();
                      const inputKeyCode = event.keyCode ? event.keyCode : event.which;
                      if (inputKeyCode != null && (inputKeyCode === 189 || inputKeyCode === 187 || inputKeyCode === 69)) {
                        setHotNotification('Should not be less than 0');
                      }
                    }}
                    type="number"
                    value={this.state.focusedCost[rowId]
                      ? this.state.focusedCost[rowId].cost
                      : (parseFloat(row.cost) === 0 || !row.cost ? '0.00' : parseFloat(row.cost).toFixed(2))
                    }
                    variant="outlined"
                  />
                </Fragment>
              );
            },
            title: () => '',
          });
        }
        fields.push({
          colSpan: 2,
          label: formatMessage('Price'),
          name: 'price',
          render: (row) => {
            const rowId = `${row.id}_${row.index}`;
            return (
              <Fragment>
                <FRInput
                  forceBlur
                  classes={{ root: row.approved ? classes.normalInput : classes.disabledInput }}
                  id="price"
                  InputProps={{
                    classes: {
                      input: row.approved ? ((row.price === '0.00' || !row.price || row.price <= row.cost) ? classes.inputZeroForQty : classes.inputNormalForQty) : classes.inputDisabledForQty,
                    },
                  }}
                  min={0}
                  name="price"
                  key={row.price}
                  onFocus={() => {
                    this.setFocusedPrice(rowId, true, '');
                  }}
                  onBlur={({ target: { value } }) => {
                    this.setFocusedPrice(rowId, false);
                    if (value === '' && parseFloat(row.price) > 0) {
                      return;
                    }
                    let floatValue = parseFloat(value || 0);
                    if (floatValue < 0) {
                      floatValue = 0;
                    }
                    if (floatValue !== parseFloat(row.price) || value === '') {
                      let newPackrows = cloneDeep(row.packrows);
                      newPackrows = packrowsWithOriginalValues(newPackrows);
                      newPackrows[row.index].price = floatValue.toFixed(2);
                      const updated = {
                        packrows: newPackrows,
                        noDispatch: true,
                      };
                      this.updateStateData(row.instance, updated);
                    }
                  }}
                  onChange={(event) => {
                    event.preventDefault();
                    const { target: { value } } = event;
                    if (parseFloat(value || 0) < 0) {
                      setHotNotification('Should not be less than 0');
                      // if (inputRef) {
                      //   inputRef.blur();
                      //   inputRef.value = 0;// eslint-disable-line
                      // }
                    }
                    this.setFocusedPrice(rowId, true, value);
                  }}
                  onKeyUp={(event) => {
                    event.preventDefault();
                    const inputKeyCode = event.keyCode ? event.keyCode : event.which;
                    if (inputKeyCode != null && (inputKeyCode === 189 || inputKeyCode === 187 || inputKeyCode === 69)) {
                      setHotNotification('Should not be less than 0');
                    }
                  }}
                  type="number"
                  value={this.state.focusedPrice[rowId]
                    ? this.state.focusedPrice[rowId].price
                    : (parseFloat(row.price) === 0 || !row.price ? '0.00' : parseFloat(row.price).toFixed(2))
                  }
                  variant="outlined"
                />
              </Fragment>
            );
          },
          title: () => '',
        });
      }

      // Hide in the following cases
      // info.id == 0: Warehouse
      if (!isFarm && !isMarketPlace && !isWarehouse) {
        fields.push({
          label: formatMessage('Cost'),
          className: row => `${`tiny-font overflow-hidden small-font ${!isCatalog && !isFarm ? 'red' : ''} ${row.approved ? '' : 'disable'} ${!isFarm ? 'blue' : ''}`}`,
          colSpan: 2,
          name: 'cost',
          render: row => (
            <div className="cost-price-same">
              <span style={{ flex: 1, fontSize: 14 }}>
                {
                  `$${formatPrice(((row.cost * (100 - (row.discount || 0))) / 100))}`
                }
              </span>
            </div>
          ),
          title: () => '',
        });
      }
      if (!isFarm && !isDistributor) {
        fields.push({
          className: row => `tiny-font ${row.approved ? (!isFarm && row.editorId !== currentUser.id && row.editorId !== null ? 'red' : null) : 'disable'}`,
          colSpan: 3,
          label: (
            <Button
              classes={{ label: classes.sortBtnLabel }}
              onClick={onSortTimeStamp}
              variant="text"
            >
              Time-Stamp
              {iconDirectionForTimestampOrder}
            </Button>
          ),
          name: 'updatedAt',
          render: data => toShortDateTimeFormat(data.updatedAt),
          title: () => '',
        });
      }
    }
    if (!isRetailPage) {
      const labelAction = (isWarehouse || isFarm) ? 'Edit' : '';
      fields.push({ label: labelAction, name: 'action', title: () => '', colSpan: readOnly ? (isMarketPlace ? 1 : 4) : 2 });
    }

    if (!isMobile && !isRetailPage && !isFarm) {
      fields.push({ 
        label: 'SKU',
        name: 'sku',
        render: row => `${row.distributorId ? 'G' : 'S'}-${ row.storeItemId && !isCatalog ? padStart(row.storeItemId, 8, '0') :padStart(row.id, 8, '0')}`, title: () => '' 
      });
    } else if (!isMobile && isRetailPage) {
      fields.push({ label: 'Item On', name: 'itemOn', title: () => '' });
      fields.push({ label: '', name: 'image', title: () => '' });
      fields.push({ label: 'Edit', name: 'edit', title: () => '' });
      fields.push({
        label: 'Time-Stamp',
        name: 'updatedAt',
        render: data => toShortDateTimeFormat(data.updatedAt),
        title: () => '',
      });
    }
    if (isFarm && !isMobile) {
      fields.push({
        className: 'category',
        colSpan: 2,
        label: formatMessage('Category'),
        name: 'category',
        render: data => (
          <div className="category-pane">
            <span className={`small-font ${data.approved ? 'category-title' : 'disable'}`}>
              <HighlightText
                highlight={searchText}
                text={toStartCaseWithSlash(data.category)}
              />
            </span>
          </div>
        ),
        title: () => '',
      });
    }

    return fields;
  }

  setFocusedPrice = (rowId, focused, price) => {
    if (focused) {
      this.setState({
        focusedPrice: {
          ...this.state.focusedPrice,
          [rowId]: {
            price,
            focused,
          },
        },
      });
    } else {
      this.setState({
        focusedPrice: {
          ...this.state.focusedPrice,
          [rowId]: undefined,
        },
      });
    }
  };

  setFocusedPacks = (rowId, focused, packs) => {
    if (focused) {
      this.setState({
        focusedPacks: {
          ...this.state.focusedPacks,
          [rowId]: {
            packs,
            focused,
          },
        },
      });
    } else {
      this.setState({
        focusedPacks: {
          ...this.state.focusedPacks,
          [rowId]: undefined,
        },
      });
    }
  };

  setFocusedBulk = (rowId, focused, bulk) => {
    if (focused) {
      this.setState({
        focusedBulk: {
          ...this.state.focusedBulk,
          [rowId]: {
            bulk,
            focused,
          },
        },
      });
    } else {
      this.setState({
        focusedBulk: {
          ...this.state.focusedBulk,
          [rowId]: undefined,
        },
      });
    }
  };

  setFocusedCost = (rowId, focused, cost) => {
    if (focused) {
      this.setState({
        focusedCost: {
          ...this.state.focusedCost,
          [rowId]: {
            cost,
            focused,
          },
        },
      });
    } else {
      this.setState({
        focusedCost: {
          ...this.state.focusedCost,
          [rowId]: undefined,
        },
      });
    }
  };

  updateDetailsData = (dataItems) => {
    const { dataFiltered } = this.state;
    const updatedData = dataItems.map((detailItem) => {
      const updatedDataItems = dataFiltered.filter(dataItem => dataItem.id === detailItem.id);
      if (updatedDataItems.length > 0 && updatedDataItems[0]) {
        const updatedDataItem = {
          ...detailItem,
          ...updatedDataItems[0],
        };
        return updatedDataItem;
      }
      return detailItem;
    });
    return updatedData;
  };

  updateItem = (updatedData) => {
    const { dataFiltered } = this.state;
    const itemIndex = dataFiltered.findIndex(item => item.id === updatedData.id);

    this.setState({
      dataFiltered: [
        ...dataFiltered.slice(0, itemIndex),
        updatedData,
        ...dataFiltered.slice(itemIndex + 1),
      ],
    });
  }

  refreshCategories = (props) => {
    const { searchText } = props;
    // const { currentCategory } = this.state;

    const filteredData = props.details.filter(subItem => includesSearchText(
      searchText,
      [
        subItem.productData.name,
        subItem.productData.subname,
        get(subItem, 'seller.companyName'),
        subItem.description,
      ],
    ));
    const newInfo = groupBy(filteredData, item => item.productData.category);
    const originalCategories = sortBy(Object.keys(newInfo));

    const categories = [];
    originalCategories.forEach((detail) => {
      categories.push({ name: detail, length: newInfo[detail].length });
    });

    // if (currentCategory == null) {
    // this.setState({
    //   filterCategories: categories,
    //   currentCategory: get(categories, '0.name'),
    // });
    // } else {
    //   this.setState({ filterCategories: categories });
    // }
  }

  toggleForShowMode = (toggled) => {
    this.setState({ showMode: toggled });
  }

  updateStateData = (instance, modifiedData, id = -1) => {
    const { storeData } = instance.state;
    let tempStoreData = storeData;
    let newStoreData = null;
    let originalStoreData = null;
    const data = {
      ...modifiedData,
    };
    if (modifiedData.packrows) {
      modifiedData.packrows = modifiedData.packrows.filter(row => !row.deleted);
      data.packrows = getValidatedPackrows(modifiedData.packrows);
    }
    if (id === -1) {
      tempStoreData = {
        ...tempStoreData,
        ...data,
      };
      newStoreData = tempStoreData;
      originalStoreData = storeData;
    } else {
      const modifiedIndex = findIndex(storeData, ['id', id]);
      tempStoreData = [...storeData];
      tempStoreData[modifiedIndex] = {
        ...tempStoreData[modifiedIndex],
        ...data,
      };
      newStoreData = tempStoreData[modifiedIndex];
      originalStoreData = storeData[modifiedIndex];
    }
    // On failure, revert the change.
    data.onFailure = () => {
      this.updateItem(originalStoreData);
    };
    const updated = this.updateStoreItem(newStoreData, data);
    if (updated) {
      instance.setState({ storeData: tempStoreData, currentTime: new Date().getTime() },
        () => this.updateItem(newStoreData));
    } else if (updated !== null) {
      const storeData = id === -1
        ? { ...originalStoreData }
        : instance.state.storeData.map(item =>
          (item.id === originalStoreData.id ? originalStoreData : item));
      instance.setState({ storeData, currentTime: new Date().getTime() },
        () => this.updateItem(originalStoreData));
    }
  }

  updateStoreItem = (storeData, modifiedData) => {
    const { setHotNotification } = this.context;
    const {
      isFarm,
      updateGoodItem,
      updateStoreItem,
      reloadStore,
    } = this.props;
    const { packrows } = modifiedData;
    if (packrows && packrows.length) {
      for (let i = 0; i < packrows.length; i++) {
        if (!packrows[i].count) {
          setTimeout(() => {
            setHotNotification({
              autoHideDuration: 3000,
              message: 'You cannot save an item with 0 count',
            });
          }, 0);
          return false;
        }
      }
    }
    if (isFarm) {
      updateStoreItem(storeData.id, modifiedData);
      if (modifiedData.onSuccess) {
        return null;
      }
    } else if (!storeData.sourceApproved && modifiedData.approved && storeData.storeItemId) {
      setHotNotification('You can not toggle on this item because it was toggled-off by seller');
      return false;
    } else {
      updateGoodItem(storeData.id, modifiedData);
      if (modifiedData.onSuccess) {
        return null;
      }
    }
    return true;
  }

  openLightbox = (item) => {
    const imageIndex = this.lightboxImages.findIndex(i => i.itemId === item.id);
    this.setState({ currentImage: imageIndex >= 0 ? imageIndex : 0, lightboxIsOpen: true });
  }

  closeLightbox = () => this.setState({ currentImage: 0, lightboxIsOpen: false })

  gotoPreviousImage = () => this.setState({ currentImage: this.state.currentImage - 1 })

  gotoNextImage = () => this.setState({ currentImage: this.state.currentImage + 1 })

  gotoImage = index => this.setState({ currentImage: index })

  handleClickLightboxImage = () => {
    if (this.state.currentImage === this.lightboxImages.length - 1) return;
    this.gotoNextImage();
  }

  handleUploadImage = () => {
    const {
      isFarm,
      createStoreItemsImage,
      createGoodsUploadImage,
    } = this.props;

    return isFarm ?
      createStoreItemsImage : createGoodsUploadImage;
  }

  // TODO: Replace me
  removeGoodsImage = () => {
    console.log('remove goods image'); // eslint-disable-line
  }

  handleRemoveImage = () => {
    const {
      isFarm,
      removeStoreItemsImage,
      removeGoodsImage,
    } = this.props;

    return isFarm ?
      removeStoreItemsImage : removeGoodsImage;
  }

  checkIsAllowedZero = (contact) => {
    const { isPublic } = this.context;
    const sellerRoleId = get(contact, 'sellerProfile.roleId');
    const sellerRole = {
      2: 'Buyer',
      3: 'Distributor',
      4: 'Seller',
      5: 'Consumer',
    }[sellerRoleId] || 'Personal';

    const buyerRoleId = get(contact, 'buyerProfile.roleId');
    const buyerRole = {
      2: 'Buyer',
      3: 'Distributor',
      4: 'Seller',
      5: 'Consumer',
    }[buyerRoleId] || 'Personal';

    return isPublic ? true : (sellerRole === 'Seller' && (buyerRole === 'Buyer' || buyerRole === 'Consumer' || buyerRole === 'Personal'));
  }

  getDataGrouped = (data) => {
    const { contact } = this.props;
    const isAllowedZero = this.checkIsAllowedZero(contact);
    const modifiedData = [];
    if (!data) return [];
    if (data) {
      let packRowCount = 0;
      data.packrows.forEach((packrow) => {
        if (parseFloat(packrow.availableQuantity, 10) === 0 && !isAllowedZero) return;
        packRowCount++;
        if (packRowCount > 1) {
          modifiedData.push({
            category: toStartCase(data.productData.category),
            ...data,
            ...packrow,
            hide: [
              'action',
              'category',
              'description',
              'image',
              'name',
              'sourcename',
              'status',
              'subname',
              'tags',
              'updatedAt',
            ],
            id: data.id,
            name: data.productData.name,
            subname: data.productData.subname,
          });
          return;
        }
        modifiedData.push({
          category: toStartCase(data.productData.category),
          ...data,
          ...packrow,
          id: data.id,
          name: data.productData.name,
          subname: data.productData.subname,
        });
      });
    }

    return modifiedData;
  };

  render() {
    const { currentUser } = this.context;
    const {
      // farmMode,
      formatMessage,
      info,
      isFarm,
      isMarketPlace,
      isCatalog,
      isWarehouse,
      readOnly,
      readOnlyForPermission,
      requesting,
      reloadStore,
      goodsUploadImageRequesting,
      storeCardPrint,
      storeItemsImageRequesting,
      // toggleForFarmMode,
      classes,
      globals,
      isMobile,
      isAllowedToUpdate,
      isRetailPage,
    } = this.props;
    // const { filterCategories, showMode, currentCategory } = this.state;
    const { currentPageIndex, dataFiltered, showMode, currentImage, lightboxIsOpen, open, dialogMessage, dirty, } = this.state;
    // const filteredData = this.getData();
    const perPage = (globals.find(({ name }) => name === 'itemsPerPage') || {}).value || 100;
    const paginatedData = dataFiltered.slice(
      (currentPageIndex - 1) * perPage,
      currentPageIndex * perPage,
    );
    this.lightboxImages = paginatedData.filter(g => !!g.image)
      .map(({ id, image, productData }) => ({
        itemId: id,
        src: image,
        caption: `${productData.category} - ${productData.name}, ${productData.subname}`,
      }));
    const fields = this.getFields();
    const fieldsForMobile = this.getFields(true);
    const pageCount = Math.ceil(dataFiltered.length / perPage);
    const imageRequesting = isFarm ? storeItemsImageRequesting : goodsUploadImageRequesting;

    const account = currentUser.account || {};
    const details = {};
    details.shopHeader = account.shopHeader;
    details.shopBody = account.shopBody;
    details.deliveryHeader = account.deliveryHeader;
    details.deliveryBody = account.deliveryBody;
    details.currentRoleId = account.currentRoleId;
    details.email = account.email;
    details.deliveryTo = account.profile.deliveryTo ? '1' : '0';
    details.pickUp = account.profile.pickUp ? '1' : '0';

    const isOrganization = Boolean(details.currentRoleId) || currentUser.organizations.filter(o => o.account.currentRoleId != null).length === 0;
    const formFields = this.getFormFields(details);
    let actualCategory = "";
    return (
      <div name="store-detail" className={`store-detail loading-enabled ${requesting && dataFiltered.length ? 'loading' : ''}`}>
        {pageCount > 1 && (
          <PaginationContainer>
            <Pagination
              active={currentPageIndex}
              batchCount={3}
              count={pageCount}
              light
              onPageClick={this.onPageClick}
            />
          </PaginationContainer>
        )}
        {/* <div className="filter-categories">
          {
            filterCategories.map((category, index) => (
              <Button
                key={index}
                classes={{
                  root: `${classes.categoryBtn} ${category.name === currentCategory ?
                    classes.activeCategoryBtn : ''}`,
                  label: `${classes.categoryBtnLabel} ${category.name === currentCategory ?
                    classes.activeCategoryBtnLabel : ''}`,
                }}
                variant="contained"
                onClick={() => this.changeFilterCategories(category.name)}
              >
                {`${category.name} (${category.length})`}
              </Button>
            ))
          }
        </div> */}
        {isRetailPage && (
          <div style={{ padding: '20px' }}>
            <SmartForm
              actionClass="profile-action"
              actionsTop={false}
              addConfirm
              placeChildrenBottom
              isOrganization={isOrganization}
              defaultData={details}
              fields={formFields}
              onSave={this.updateProfile}
              onUpdate={this.setFormDirty}
              saveButton={formatMessage('SAVE RETAIL SHOP')}
              saveButtonDisable={false}
              saveConfirm={!currentUser.roleId && isOrganization ? formatMessage('Create a business account with a user type: ') : ''}
            />
            <Prompt
              message={formatMessage('Pending Changes')}
              when={dirty}
            />
          </div>
        )}
        <div className="mobile-tool-bar">
        {(isFarm || isWarehouse) && (
          <div className="view-mode">
            <Tabs
              classes={{
                indicator: classes.tabIndicator,
                root: classes.tabsContainer,
              }}
              fullWidth
              onChange={(e, value) => this.setState({ showMode: Boolean(value) })}
              style={{ marginBottom: 5 }}
              value={showMode ? 1 : 0}
            >
              <Tab
                className="source-tab"
                classes={{
                  label: classes.tabLabel,
                  root: classes.tab,
                }}
                label={isFarm ? formatMessage('View Store') : formatMessage('All')}
                value={1}
              />
              <Tab
                className="source-tab"
                classes={{
                  label: classes.tabLabel,
                  root: classes.tab,
                }}
                label={isFarm ? formatMessage('Edit Store') : formatMessage('Images')}
                value={0}
              />
            </Tabs>
            {(isFarm || !info.id) && (
              <div className="group-tool-add-item" style={{ padding: '10px 0px' }}>
                <AddItemButton
                  contactId={info.id}
                  disabled={isAllowedToUpdate ? readOnlyForPermission : true}
                  formatMessage={formatMessage}
                  reloadStore={reloadStore}
                  isRetailPage={isRetailPage}
                />

              </div>
            )}
          </div>
          )}
          { isFarm && storeCardPrint}
        </div>
        {
          requesting && !dataFiltered.length && (
            <div className="store-progress">
              <CircularProgress />
            </div>
          )
        }
        {
          showMode ? (
            paginatedData.length ? (
              isFarm ? (
                <div>
                  <Grid container spacing={24} style={!isMobile ? { maxWidth: '1200px', margin: 'auto' } : {}}>
                    {sortBy(paginatedData, ['category', 'productData.name', 'packrows[0].count']).filter(item => item.approved).map((item, index) => {
                      const data = this.getDataGrouped(item);

                      return (
                        data.map((row, index) => {
                          const imageUrl = row.image || '/assets/images/image-not-available-1.png';
                          const val = formatPrice(((row.price * (100 - (row.discount || 0))) / 100)).toString();
                          const dec_pos = val.indexOf('.');
                          const showCategoryTitle = actualCategory === row.category ? false : true;
                          actualCategory = row.category;

                          return (
                            isMobile ? (
                              <Grid item key={index} xs={12} sm={12} md={12} style={{ padding: 0 }}>
                                {showCategoryTitle && <div style={{ fontSize: 22, fontWeight: 300, color: "grey", paddingBottom: 15, paddingTop: 15, paddingLeft: 15, textAlign: "left" }}>{row.category}</div>}
                                <Card className={classes.cardMobile}>
                                  <div>
                                    <img src={imageUrl} alt="" width="170" height="130" style={{ objectFit: 'cover' }}></img>
                                  </div>
                                  <CardContent className={classes.cardContentMobile}>
                                    <Typography gutterBottom variant="h5" component="h2" style={{ fontSize: "17px", fontWeight: 500 }}>
                                      {row.name},
                                            <span>&nbsp;{row.subname.substring(0, 13)} {row.subname.length > 13 ? "..." : ""}  </span>
                                      <span style={{ fontWeight: 300 }}>{row.tags.join(", ")}  </span>
                                    </Typography>
                                    {row.description.length > 0 && (
                                      <div style={{ fontSize: "12px", color: "grey" }}>
                                        {row.description.substring(0, 25)} {row.description.length > 25 ? "..." : ""}
                                      </div>
                                    )
                                    }
                                  </CardContent>
                                </Card>
                              </Grid>
                            ) : (
                                <Grid item key={index} style={{ width: '240px' }} >
                                  <Card className={classes.card}>
                                    <CardMedia
                                      className={classes.cardMedia}
                                      image={imageUrl}
                                      title=""
                                    />
                                    <CardContent className={classes.cardContent}>
                                      <Typography gutterBottom variant="h5" component="h2" style={{ fontSize: "17px", fontWeight: 500 }}>
                                        {row.name},<span>&nbsp;{row.subname}  </span>
                                        <span style={{ fontWeight: 300 }}>{row.tags.join(", ")}  </span>
                                      </Typography>
                                      <div style={{ marginTop: "8px", fontSize: "12px", color: '#151b1e80' }}>
                                        {row.description.substring(0, 35)} {row.description.length > 35 ? "..." : ""}
                                      </div>
                                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: "10px", marginBottom: "10px" }}>
                                        <div key={index} className="uom" style={{ fontSize: "13px", fontWeight: 'bold' }}>
                                          <span>{`${row.count} ${row.uom} ${row.pack}`}</span>
                                        </div>
                                        <div style={{ fontSize: "16px", fontWeight: 'bold' }} >
                                          <span>
                                            {`${val.substring(0, dec_pos)}`}<sup> {`${val.substring(dec_pos + 1)}`}</sup>
                                          </span>
                                        </div>
                                      </div>
                                    </CardContent>
                                  </Card>
                                </Grid>
                              )
                          )
                        })
                      )
                    })
                    }
                  </Grid>
                </div>
              ) : (
                  <div>
                    <div className="smart-table">
                      {
                        <StoreTable
                          fields={fields}
                          threshold="md"
                          isRetailPage={isRetailPage}
                        >
                          {
                            paginatedData.map((tempDataItem, index) => (
                              <StoreTable.StoreTableRow
                                onUploadImage={this.handleUploadImage()}
                                onRemoveImage={this.handleRemoveImage()}
                                imageRequesting={imageRequesting}
                                data={tempDataItem}
                                fields={fields}
                                formatMessage={formatMessage}
                                id={this.props.info.id}
                                isCatalog={isCatalog}
                                isFarm={isFarm}
                                isMarketPlace={isMarketPlace}
                                isWarehouse={isWarehouse}
                                key={index}
                                readOnly={readOnly}
                                readOnlyForPermission={readOnlyForPermission}
                                reloadStore={reloadStore}
                                onImageClick={() => this.openLightbox(tempDataItem)}
                                updateStateData={this.updateStateData}
                                isAllowedToUpdate={isAllowedToUpdate}
                                isRetailPage={isRetailPage}
                                classes={classes}
                              />
                            ))
                          }
                        </StoreTable>
                      }
                      {
                        <StoreTable.StoreMobileTable
                          threshold="md"
                        >
                          {
                            paginatedData.map((tempDataItem, index) => (
                              <StoreTable.StoreMobileTableRow
                                onUploadImage={this.handleUploadImage()}
                                onRemoveImage={this.handleRemoveImage()}
                                imageRequesting={imageRequesting}
                                data={tempDataItem}
                                fields={fieldsForMobile}
                                formatMessage={formatMessage}
                                key={index}
                                id={this.props.info.id}
                                isCatalog={isCatalog}
                                isFarm={isFarm}
                                isMarketPlace={isMarketPlace}
                                readOnly={readOnly}
                                readOnlyForPermission={readOnlyForPermission}
                                reloadStore={reloadStore}
                                updateStateData={this.updateStateData}
                                threshold="s"
                                onImageClick={() => this.openLightbox(tempDataItem)}
                                isRetailPage={isRetailPage}
                              />
                            ))
                          }
                        </StoreTable.StoreMobileTable>
                      }
                    </div>
                  </div>
                )
            )
              : ''
          ) : (
              isFarm ? (
                <div>
                  <div className="smart-table">
                    {
                      <StoreTable
                        fields={fields}
                        threshold="md"
                        isRetailPage={isRetailPage}
                      >
                        {
                          paginatedData.map((tempDataItem, index) => (
                            <StoreTable.StoreTableRow
                              onUploadImage={this.handleUploadImage()}
                              onRemoveImage={this.handleRemoveImage()}
                              imageRequesting={imageRequesting}
                              data={tempDataItem}
                              fields={fields}
                              formatMessage={formatMessage}
                              id={this.props.info.id}
                              isCatalog={isCatalog}
                              isFarm={isFarm}
                              isMarketPlace={isMarketPlace}
                              key={index}
                              readOnly={readOnly}
                              readOnlyForPermission={readOnlyForPermission}
                              reloadStore={reloadStore}
                              onImageClick={() => this.openLightbox(tempDataItem)}
                              updateStateData={this.updateStateData}
                              isAllowedToUpdate={isAllowedToUpdate}
                              isRetailPage={isRetailPage}
                              classes={classes}
                            />
                          ))
                        }
                      </StoreTable>
                    }
                    {
                      <StoreTable.StoreMobileTable
                        threshold="md"
                      >
                        {
                          paginatedData.map((tempDataItem, index) => (
                            <StoreTable.StoreMobileTableRow
                              onUploadImage={this.handleUploadImage()}
                              onRemoveImage={this.handleRemoveImage()}
                              imageRequesting={imageRequesting}
                              data={tempDataItem}
                              fields={fieldsForMobile}
                              formatMessage={formatMessage}
                              key={index}
                              id={this.props.info.id}
                              isCatalog={isCatalog}
                              isFarm={isFarm}
                              isMarketPlace={isMarketPlace}
                              readOnly={readOnly}
                              readOnlyForPermission={readOnlyForPermission}
                              reloadStore={reloadStore}
                              updateStateData={this.updateStateData}
                              threshold="s"
                              onImageClick={() => this.openLightbox(tempDataItem)}
                              isRetailPage={isRetailPage}
                            />
                          ))
                        }
                      </StoreTable.StoreMobileTable>
                    }
                  </div>
                </div>
              ) : (
                  <div className={`grid-view ${classes.root}`}>
                    <GridView
                      onUploadImage={this.handleUploadImage()}
                      onRemoveImage={this.handleRemoveImage()}
                      imageRequesting={imageRequesting}
                      formatMessage={formatMessage}
                      id={this.props.info.id}
                      info={paginatedData}
                      isFarm={isFarm}
                      isMarketPlace={isMarketPlace}
                      readOnly={readOnly}
                      readOnlyForPermission={readOnlyForPermission}
                      reloadStore={reloadStore}
                      onItemImageClick={this.openLightbox}
                      updateStateData={this.updateStateData}
                      isRetailPage={isRetailPage}
                    />
                    <MobileGridView
                      onUploadImage={this.handleUploadImage()}
                      onRemoveImage={this.handleRemoveImage()}
                      imageRequesting={imageRequesting}
                      formatMessage={formatMessage}
                      id={this.props.info.id}
                      info={paginatedData}
                      isFarm={isFarm}
                      isMarketPlace={isMarketPlace}
                      readOnly={readOnly}
                      readOnlyForPermission={readOnlyForPermission}
                      reloadStore={reloadStore}
                      threshold="md"
                      onItemImageClick={this.openLightbox}
                      updateStateData={this.updateStateData}
                      isRetailPage={isRetailPage}
                    />
                  </div>
                )
            )
        }
        {readOnly &&
          <Lightbox
            currentImage={currentImage}
            images={this.lightboxImages}
            isOpen={lightboxIsOpen}
            onClickImage={this.handleClickLightboxImage}
            onClickNext={this.gotoNextImage}
            onClickPrev={this.gotoPreviousImage}
            onClickThumbnail={this.gotoImage}
            onClose={this.closeLightbox}
            showThumbnails
          />
        }
        <Dialog
          open={open}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">Description</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              { dialogMessage }
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary" autoFocus>
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

/* istanbul ignore next */
const mapStateToProps = state => ({
  ...selectState('goods', 'goodsUploadImage')(state, 'goodsUploadImage'),
  ...selectState('goods', 'goodsImage')(state, 'goodsImage'),
  ...selectState('storeItems', 'storeItemsImage')(state, 'storeItemsImage'),
  ...selectState('options', 'globals')(state, 'globals'),
  ...selectState('options', 'tags')(state, 'tags'),
});

export default compose(
  setDisplayName('StoreCardDetails'),
  connect(
    mapStateToProps,
    dispatchRestMaker([
      [goodActions, 'goodItem'],
      [goodsUploadImageActions, 'goodsUploadImage'],
      [goodsImageActions, 'goodsImage'],
      [storeActions, 'storeItem'],
      [storeItemsImageActions, 'storeItemsImage'],
    ]),
  ),
  withStyles(styles),
  injectIntl,
  immutableToJS,
)(StoreCardDetails);
